import React, { PropTypes } from 'react';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
// import { this.props.history } from '../../store/configureStore';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../actions/appointmentActions';
import Pagination from "react-js-pagination";
import * as SVGICONS from '../../images/img/images';
import Moment from 'react-moment';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as constant from '../../constants/constant';
// import VideoCall from '../videocall/components/App';
// import { OTSession, OTPublisher, OTStreams, OTSubscriber } from 'opentok-react';
import ReactTooltip from 'react-tooltip';
import FeedbackRemainder from './feedbackRemainder';
import RateModal from '../rating/addRating';
import RateingDisclamer from '../rating/addRatingDisclamer';
// import {
// 	confirmAlert
// } from 'react-confirm-alert';
import { constants } from 'os';
import moment from 'moment';
import momentzone from 'moment-timezone'
import $ from 'jquery'
import getSymbolFromCurrency from 'currency-symbol-map'
class MyAppointment extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: false,
			appointmentList: [],
			token: '',
			patientId: '',
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			grid: false,
			list: true,
			searchText: '',
			API_KEY: '',
			TOKEN: '',
			SESSION_ID: '',
			openVideoRoom: false,
			//Feedback Remainder
			pendingFeedback: {},
			isRateReminderOpen: false,
			doctorName: '',
			rateAppDate: '',
			rateAppTime: '',
			isRateModalOpen: false,
			rateAppId: '',
			rateDrId: '',
			counter: 0,
			isDisclaimer: localStorage.getItem('isDisclaimerFeedback') ? localStorage.getItem('isDisclaimerFeedback') : false
			// isRatedDoctor: false
		};
		this.toggleview = this.toggleview.bind(this);
		this.deleteAppointment = this.deleteAppointment.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.bookAppointment = this.bookAppointment.bind(this);
		this.goToDetailsPage = this.goToDetailsPage.bind(this);
		this._sortClass = this._sortClass.bind(this);
		this.sortChanged = this.sortChanged.bind(this);
		this.search = this.search.bind(this);
		this.createSessionIdToken = this.createSessionIdToken.bind(this);
		this.closeRemainderModal = this.closeRemainderModal.bind(this);
		this.openRateCloseRemainderModal = this.openRateCloseRemainderModal.bind(this);
		this.closeRateModal = this.closeRateModal.bind(this);
		this.closeRateModalOpenReminder = this.closeRateModalOpenReminder.bind(this);
		this.nextRateReminder = this.nextRateReminder.bind(this);
		// this.sortChanged = this.sortChanged.bind(this)
		// this.openCloseDisclaimerModal = this.openCloseDisclaimerModal.bind(this);
		this.closeDisclaimer = this.closeDisclaimer.bind(this);
	}
	// openCloseDisclaimerModal(){
	// 	this.setState({isDisclaimer:false , isRateReminderOpen: true });

	// }
	openRateCloseRemainderModal() {
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className='custom-ui disclaimer_appointement'>
						<a style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>

						<h1>Disclaimer</h1>
						{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
						<span>Your feedback should not identify or make reference to any individual, living or otherwise, in any way, whether in a positive or negative light.  You must also be objective in your feedback, with an emphasis on tangible actions recorded in your feedback post.  The aim of the feedback mechanism is to guide other prospective patients, any official or unofficial complaints should be followed up with Medfix Support Team.  All posts are moderated before being published and may be declined or withdrawn at any time.  Your use of the feedback system constitutes acceptance of the Medfix Terms and Conditions.</span>
						<div className="bottomBtn text-center"><button type="button" onClick={() => {
							this.setState({ isRateReminderOpen: false, isRateModalOpen: true });
							onClose()
						}} className="btn btn-warning btn-lg">Ok</button></div>
					</div>
				)
			}
		})


	}
	closeRemainderModal() {
		this.setState({ isRateReminderOpen: false });
	}
	closeRateModalOpenReminder() {
		this.setState({ isRateModalOpen: false, isRateReminderOpen: true });
	}
	closeDisclaimer() {
		// debugger;
		this.setState({ isDisclaimer: false });
	}
	closeRateModal() {
		this.setState({ isRateModalOpen: false, isRateReminderOpen: false });
	}
	componentWillMount() {
console.log("==>>", this.props)
		let datenow = new Date();
		console.log("+++++++++++new DATE", datenow.toLocaleTimeString());
		let userToken = localStorage.getItem('token');
		let patientId = localStorage.getItem('userId');

		let appointmentObj = {
			token: userToken,
			patientId: patientId,
			flag: 1,
			count: this.state.count,
			sortOrder: 1,
			page: 1
		};
		this.props.actions.getAppointments(appointmentObj);

		var obj2 = {
			patientId: patientId
		}
		this.props.actions.getReminderList(obj2);

		this.changeAptType = this.changeAptType.bind(this);
		this.sortChanged('appointmentDate', -1)

		this.state.current = 1;


	}
	componentDidMount() {
	}
	componentWillReceiveProps(nextProps) {
		const { appointmentList, totalCount, pendingFeedback } = nextProps;
		// if (appointmentList && totalCount && pendingFeedback) {
			this.setState({
				appointmentList: (nextProps.appointmentList) ? nextProps.appointmentList : [],
				totalCount: nextProps.totalCount ? nextProps.totalCount : 0,
				isLoader: false,
				pendingFeedback: nextProps.pendingFeedback ? nextProps.pendingFeedback : {},

			});
		// }


		if (nextProps.pendingFeedback && nextProps.pendingFeedback.hasOwnProperty('doctorId') && this.state.isRateReminderOpen == false && JSON.parse(localStorage.getItem('feedbackRemind')) == true) {
			this.setState({
				doctorName: nextProps.pendingFeedback.doctorName,
				isRateReminderOpen: true,
				rateAppDate: nextProps.pendingFeedback.checkappointmentDate,
				rateAppTime: nextProps.pendingFeedback.appointmentDateUTC,
				rateAppId: nextProps.pendingFeedback._id,
				rateDrId: nextProps.pendingFeedback.doctorId._id,
				isDisclaimer: true
			});

		}

		if (localStorage.getItem('isClicked') === "true") {
			localStorage.removeItem('isClicked')

			this.changeAptType(1)
		}


	}
	nextRateReminder() {
		var obj = {
			patientId: localStorage.getItem('userId'),
			appointmentId: this.state.rateAppId
		}
		this.props.actions.getNextReminder(obj);
		this.closeRemainderModal();
	}

	deleteAppointment(data) {
		var firstName = data.doctorInfo[0].firstName.charAt(0).toUpperCase() + data.doctorInfo[0].firstName.slice(1)
		var lastName = data.doctorInfo[0].lastName ? data.doctorInfo[0].lastName.charAt(0).toUpperCase() + data.doctorInfo[0].lastName.slice(1) : ''
		var DoctorName = firstName + ' ' + lastName
		let nowDiffFromAppointment = /* Math.abs( */(new Date(data.checkappointmentDate) - new Date())/36e5;
		if (nowDiffFromAppointment > 0) {
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to cancel the booked appointment with Dr ' + DoctorName + '?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						let appointmentObj = {
							// token: userToken,
							appointmentId: data._id,
							flag: this.state.flag,
							count: this.state.count,
							page: this.state.activePage,
							patientId: localStorage.getItem('userId'),
							userType: 'Patient'
						};

						this.props.actions.deleteAppointment(appointmentObj);
						let userToken = localStorage.getItem('token');
						let patientId = localStorage.getItem('userId');
						//	toast.info(" Your Appointment has been cancelled");
						let getappointmentObj = {
							token: userToken,
							patientId: patientId,
							flag: 1,
							count: this.state.count,
							sortOrder: 1,
							page: 1
						};
						this.props.actions.getAppointments(getappointmentObj, this.props);
					}
				},
				{
					label: 'No',
					onClick: () => { this.props.history.push('/dashboard/my-appointment'); }
				}
			]
		})
	}else {
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className='custom-ui disclaimer_appointement'>
					<a  style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>

						<h1>Error</h1>
						{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
						<span>You can't cancel the appointment after appointment time has passed.</span>
						<div className="bottomBtn text-center"><button type="button"  onClick={onClose}	 className="btn btn-warning btn-lg">Ok</button></div>
					</div>
				)
			}
		})
	}

	}

	bookAppointment(id) {
		if (id) {
			localStorage.availabilityId = id;
			// window.location.href = constant.PRODUCTION_CURRENT_URL + "book-appointment-calendar"
			this.props.history.push('/dashboard/book-appointment-calendar');
		}

	}
	search(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
		if (event.target.value.length > 3 || event.target.value == '') {
			let userToken = localStorage.getItem('token');
			let patientId = localStorage.getItem('userId');

			let appointmentObj = {
				token: userToken,
				patientId: patientId,
				flag: this.state.flag,
				count: 10,
				sortOrder: this.state.sortOrder,
				page: 1,
				sorting: this.state.sorting,
				searchText: event.target.value
			};
			this.props.actions.getAppointments(appointmentObj);
		}
	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let userToken = localStorage.getItem('token');
		let patientId = localStorage.getItem('userId');

		let appointmentObj = {
			token: userToken,
			patientId: patientId,
			flag: this.state.flag,
			count: this.state.count,
			page: pageNumber,
			sortOrder: this.state.sortOrder,
			sorting: this.state.sorting,
		};
		this.props.actions.getAppointments(appointmentObj);
	}


	changeAptType(data) {
		var state = this.state;

		this.setState(state);

		let userToken = localStorage.getItem('token');
		let patientId = localStorage.getItem('userId');
		let appointmentObj = {
			token: userToken,
			patientId: patientId,
			flag: data,
			page: 1,
			count: this.state.count,
			sortOrder: this.state.sortOrder,
			searchText: this.state.searchText
		};
		this.setState({
			flag: data
		})
		// return
		this.props.actions.getAppointments(appointmentObj);
		var obj2 = {
			patientId: patientId
		}
		this.props.actions.getReminderList(obj2);
		// this.sortChanged('appointmentDate', this.state.sortOrder)

	}

	goToDetailsPage(availabilityId, doctorId) {
		localStorage.setItem('specialistId', doctorId)
		this.props.history.push('/dashboard/specialist-details/' + availabilityId);
	};
	goToAppDetailsPage(aptId) {
		this.props.history.push('/dashboard/appointment-details/' + aptId);
	}
	toggleview(data) {
		let userToken = localStorage.getItem('token');
		let patientId = localStorage.getItem('userId');
		let appointmentObj = {
			token: userToken,
			patientId: patientId,
			flag: this.state.flag,
			page: this.state.activePage,
			count: this.state.count,
			sortOrder: this.state.sortOrder,
			sorting: this.state.sorting,
			searchText: this.state.searchText
		};
		this.props.actions.getAppointments(appointmentObj);
		if (data == 'grid') {
			this.setState({ list: false, grid: true })
			$('.cbp-vm-list').removeClass('cbp-vm-selected');
			$('.cbp-vm-grid').addClass('cbp-vm-selected');
		} else {
			$('.cbp-vm-grid').removeClass('cbp-vm-selected')
			$('.cbp-vm-list').addClass('cbp-vm-selected')
			this.setState({ list: true, grid: false })
		}
	}



	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}
	createSessionIdToken(item) {
		// console.log(item, 'item')
		var videoCall = {
			appointmentId: item._id,
			patientId: item.patientId,
			doctorId: item.doctorId
		}
		localStorage.setItem('videoCall', JSON.stringify(videoCall))
		this.props.history.push("/waiting-room-caller")
	}
	//function for sorting
	sortChanged(sortColumnName, order, e) {

		// e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		let patientId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let appointmentObj = {
			token: userToken,
			patientId: patientId,
			flag: this.state.flag,
			page: this.state.activePage,
			count: this.state.count,
			sorting: sorting,
			sortOrder: this.state.sortOrder,
		};

		this.props.actions.getAppointments(appointmentObj);
	}

	goToPaymentPage = (appointmentId) => {
		localStorage.setItem('appointmentId', appointmentId);
		this.props.history.push(
			{
				pathname: '/dashboard/appointment-payment',
				state: { detail: 'cashpPayment' }
			})
		
	}

	render() {
		var defaultImagePath = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		var appointmentsList = this.state.appointmentList;
		var rowsGrid = [];
		var rowsList = [];
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		this.state.appointmentList.forEach(function (item, index) {
			var splittime = item.appointmentTime.split(":")
			var hours = ('0' + splittime[0]).slice(-2)
			var min = splittime[1]
			item.appointmentTime = hours + ':' + min;
			var image
			if (item.specialistsInfo && item.specialistsInfo.length > 0 && item.specialistsInfo[0].profileImage && item.specialistsInfo[0].profileImage != '' && item.specialistsInfo[0].profileImage != 'noUserImage.jpg') {
				image = constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.specialistsInfo[0].userId + '/' + item.specialistsInfo[0].profileImage
			} else {
				image = (item.doctorInfo && item.doctorInfo[0].gender == 'Male') ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
			}
			if (item.doctorInfo) {
				rowsList.push(<tr key={index}>
					<td><img src={image} onError={(e) => { e.target.src = defaultImagePath }} /></td>
					<td><Link className="bookagainLinkWhithoutunderline text-capitalize" href="#" onClick={this.goToDetailsPage.bind(this, item.availabilityId, item.doctorInfo[0]._id)}>Dr. 				{item.doctorInfo[0].firstName} {item.doctorInfo[0].lastName}
					</Link></td>

					{/* <td><Link className="bookagainLinkWhithoutunderline" href="#" onClick={this.goToAppDetailsPage.bind(this, item._id)}> <Moment format="DD-MMM-YYYY">{item.appointmentDate}</Moment></Link></td>
					<td>{item.appointmentTime}</td> */}

					{/* <td><Link className="bookagainLinkWhithoutunderline" href="#" onClick={this.goToAppDetailsPage.bind(this, item._id)}>   {item ? moment(moment.utc(item.appointmentDate).toDate()).format('DD-MMM-YYYY') : ''}</Link></td> */}
					{/* <td>{item ? moment(moment.utc(item.appointmentDate, "h:mm:ss A").toDate()).format("HH:mm") : ''}</td> */}
					<td><Link className="bookagainLinkWhithoutunderline" href="#" onClick={this.goToAppDetailsPage.bind(this, item._id)}>   {item ? moment.parseZone(new Date(item.checkappointmentDate)).format('DD-MM-YYYY') : ''}</Link></td>
					<td>{item ? moment.parseZone(new Date(item.checkappointmentDate)).format('hh:mm A') + " " + userlocation : ''}</td>
					{/* <td>{item ? item.clinicName : ''}</td> */}

					<td>{item.appointmentMode == 1 ? 'Face To Face' : 'Online'} </td>
				{item.doctoravailabilities && item.doctoravailabilities[0] && item.doctoravailabilities[0].currencySymbol != 'AED' ? <td style={{"text-align": "center"}}>	{getSymbolFromCurrency(item.doctoravailabilities ? item.doctoravailabilities[0].currencySymbol : '')} {item.fee}{item.paid == false && item.appointmentPaymentMethod == 'Card' && <button type="button" className="btn btn-block btn-warning consultBtnTd" onClick={() => this.goToPaymentPage(item._id)}>Pay</button>} </td> : <td> {item.fee} د.إ{item.paid == false && item.appointmentPaymentMethod == 'Card' && <button type="button" className="btn btn-block btn-warning consultBtnTd">Pay</button>}</td>}
					{item.appointmentStatus == 1 ? <td className="cbp-vm-icon cbp-vm-Status statusGreen">Confirmed</td> : item.appointmentStatus == 2 ? <td className="cbp-vm-icon cbp-vm-Status statusGreen">Completed</td> : item.appointmentStatus == 3 ? <td className="cbp-vm-icon cbp-vm-Status statusRed">No show-Specialist </td> : item.appointmentStatus == 4 ? <td className="cbp-vm-icon cbp-vm-Status statusRed">No show-Patient</td> : item.appointmentStatus == 5 ? <td><Link to={{pathname: '/dashboard/appointment-details', data:{appointmentId: item._id}}}>Reserved </Link></td> : item.appointmentStatus == 6 ? <td className="cbp-vm-icon cbp-vm-Status statusOrange">Cancelled By {item.isDeletedBy}</td> : item.appointmentStatus == 7 ? <td className="cbp-vm-icon cbp-vm-Status statusOrange">Cancelled By {item.isDeletedBy}</td> : <td></td>}
					{this.state.flag == 2 ? <td><Link className="bookagainLink" href="#" onClick={this.bookAppointment.bind(this, item.availabilityId)}>Book Again</Link></td> : <td className="display_ipad"></td>}
					{/* {this.state.flag == 1 && item.appointmentMode == 2 ? <td><Link href="#" data-tip="Call specialist " onClick={this.createSessionIdToken.bind(this, item)}> <SVGICONS.PhoneSvg /></Link> </td> : <td className="display_ipad"></td>} */}
					{this.state.flag == 1 ? <td>
						{/* <span > */}
						<a href="#" className="tooltip-custom fadeEffect tisymtomhover cancelRightTooltip" data-title="Cancel appointment" onClick={this.deleteAppointment.bind(this, item)}><SVGICONS.CancelSvg />
						</a>

						{/* </span> */}


					</td> : <td></td>}
				</tr>)

			}
		}.bind(this));
		{
			this.state.appointmentList && this.state.appointmentList.length > 0 ? this.state.appointmentList.forEach(function (item, index) {
				var image
				if (item.specialistsInfo && item.specialistsInfo.length > 0 && item.specialistsInfo[0].profileImage && item.specialistsInfo[0].profileImage != '' && item.specialistsInfo[0].profileImage != 'noUserImage.jpg') {
					image = constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.specialistsInfo[0].userId + '/' + item.specialistsInfo[0].profileImage
				} else if(this.state.appointmentList.length > 0 && this.state.appointmentList[0].doctorInfo){
					{
						this.state.appointmentList[0].doctorInfo[0].gender == 'Male' ? image = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : image = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
					}
				}
				if(item.doctorInfo){
				rowsGrid.push(<li className="col-sm-3 ipad_landscape" key={index}>
					<div className="gridView">
						<div className="cbp-vm-image"><span className="dotGreen"></span><img src={image} onError={(e) => { e.target.src = defaultImagePath }} /></div>
						<div className="cbp-vm-title text-capitalize"><span> Specialist Name </span>
							{item.doctorInfo ? <Link className="bookagainLinkWhithoutunderline text-capitalize" href="#" onClick={this.goToDetailsPage.bind(this, item.availabilityId, item.doctorInfo[0]._id)}>Dr.
							{item.doctorInfo[0].firstName} {item.doctorInfo[0].lastName}
							</Link>
								: ''
							}
						</div>
						<div className="cbp-vm-price " ><span>Appointment Date</span>
							<Link className="bookagainLinkWhithoutunderline " href="#" onClick={this.goToAppDetailsPage.bind(this, item._id)}>
								<Moment style={{ "whiteSpace": "nowrap" }} format="DD-MM-YYYY">{item.checkappointmentDate}</Moment>

							</Link>
						</div>
						<div className="cbp-vm-price " ><span>Appointment Time</span>{item ? moment.parseZone(new Date(item.checkappointmentDate)).format('h:mm A') : ''}</div>
						{/* <div className="cbp-vm-price " ><span>Clinic Name</span>{item ? item.clinicName : ''}</div> */}
						<div className="cbp-vm-details"> <span>Mode </span>{item.appointmentMode == 1 ? 'F2F' : 'Online'} </div>
						{item.doctoravailabilities && item.doctoravailabilities[0] && item.doctoravailabilities[0].currencySymbol != 'AED' ? <div className="cbp-vm-icon cbp-vm-add"><span> Consultation Fees </span>
							{getSymbolFromCurrency(item.doctoravailabilities ? item.doctoravailabilities[0].currencySymbol : '')}
							{item.fee} </div>
							: <div className="cbp-vm-icon cbp-vm-add"><span> Consultation Fees </span>
								{/* {getSymbolFromCurrency(item.doctoravailabilities ? item.doctoravailabilities[0].currencySymbol : '')}  */}
								{item.fee} د.إ  </div>
						}
						{item.appointmentStatus == 1 ? <div className="cbp-vm-icon cbp-vm-Status statusGreen" ><span> Status </span>Confirmed</div> : item.appointmentStatus == 2 ? <div className="cbp-vm-icon cbp-vm-Status statusOrange" ><span> Status </span>Completed</div> : item.appointmentStatus == 3 ? <div className="cbp-vm-icon cbp-vm-Status statusRed" ><span> Status </span>No Show-Specialist</div> : item.appointmentStatus == 4 ? <div className="cbp-vm-icon cbp-vm-Status statusRed" ><span> Status </span>No Show-Patient </div> : item.appointmentStatus == 5 ? <div className="cbp-vm-icon cbp-vm-Status" ><span> Status </span>Reserved</div> :
							item.appointmentStatus == 6 ? <div className="cbp-vm-icon cbp-vm-Status" ><span> Status </span>Cancelled By {item.isDeletedBy}</div> : ''}

						{/* <div className="cbp-vm-icon cbp-vm-Status" style={{ display: item.appointmentStatus == 2 ? 'block' : 'none' }}><span> Status </span>Completed</div>
						<div className="cbp-vm-icon cbp-vm-Status" style={{ display: item.appointmentStatus == 4 ? 'block' : 'none' }}><span> Status </span>Patient No Show</div> */}
						{this.state.flag == 2 ? <div className="cbp-vm-icon bookAgain"><span>	<Link className="bookagainLink" href="#" onClick={this.bookAppointment.bind(this, item.availabilityId)}>
							{item.availabilityId ? 'Book Again' : ''}
						</Link> </span></div> : ''}
						{/* <div className="cbp-vm-icon cbp-vm-call text-yellow ">
							{this.state.flag == 1 && item.appointmentMode == 2 ? <Link href="#" data-tip="Call specialist " onClick={this.createSessionIdToken.bind(this, item)}> <SVGICONS.PhoneSvg /></Link> : ''}
						</div> */}
						{this.state.flag == 1 ? <div className="cbp-vm-icon cbp-vm-close cross-spacing">
							<span className="tooltip-custom fadeEffect tisymtomhover cancelRightTooltip tooltip-grid" data-title="Cancel appointment">
								<Link href="#" onClick={this.deleteAppointment.bind(this, item)}>
									<SVGICONS.CancelSvg />
								</Link>
							</span>

						</div> : ''}
					</div>
				</li>)
				}
			}.bind(this)) : ''
		}



		return (
			<div className="content-wrapper">

				{this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
					<section className="content container-fluid ipad-spacing">
						<ReactTooltip />
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs upcomingInfo">
											<li><Link href="#tab_1" className={this.state.flag === 1 ? "active show" : ''} data-toggle="tab" onClick={this.changeAptType.bind(this, 1)}>Upcoming Appointments</Link></li>
											<li><Link href="#tab_1" className={this.state.flag === 2 ? "active show" : ''} data-toggle="tab" onClick={this.changeAptType.bind(this, 2)}>Past Appointments</Link></li>

										</ul>
										<div className="upcomingSearch">
											<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/search.png')} alt="" /></i></span>
												<input type="text" name="searchText" className="form-control" onChange={this.search.bind(this)} value={this.state.searchText} placeholder="Search by Specialist Name" />
											</div>
											{/* </div> */}
										</div>
										<div className="tab-content" style={{ "minHeight": 410 }}>
											<div className="tab-pane active" id="tab_1">
												<div id="cbp-vm" className="cbp-vm-switcher cbp-vm-view-grid">
													<div className="cbp-vm-options">
														<Link to="#" onClick={this.toggleview.bind(this, 'grid')} className="cbp-vm-icon cbp-vm-grid">Grid View</Link>
														<Link to="#" onClick={this.toggleview.bind(this, 'list')} className="cbp-vm-icon cbp-vm-list cbp-vm-selected"></Link> </div>
													{/* table here */}
													<div className="mbTab">
														<div className="cbpTitle cbp-vm-view-list">
															<div className="cbpTitle1"></div>
															<div className="cbpTitle2">Specialist Name</div>
															<div className="cbpTitle3">Appointment Date </div>
															<div className="cbpTitle3">Appointment Time </div>

															{/* <div className="cbpTitle3">Clinic Name </div> */}

															<div className="cbpTitle4"> Mode </div>
															<div className="cbpTitle5">Consultation Fees </div>
															<div className="cbpTitle6">Status</div>
															<div className="cbpTitle6">&nbsp; </div>
															{/* <div className="cbpTitle6">&nbsp; </div> */}
														</div>
														<div style={{ display: this.state.grid ? 'block' : 'none' }}>
															<ul className="row">
																{rowsGrid && rowsGrid.length > 0 ? rowsGrid : <li className="col-sm-12"><div className="gridView noUpcoming">There are no {this.state.flag == 1 ? "upcoming" : "past"} appointments.</div></li>}
															</ul>
														</div>
														<div style={{ display: this.state.list ? 'block' : 'none' }}>
															<div className="table-responsive">
																<table className="table  table-hover tableList">
																	<thead>
																		<tr>
																			<th></th>
																			<th
																				onClick={this.sortChanged.bind(this, 'doctorInfo.firstName', this.state.sortOrder)}>
																				Specialist Name
                                <i className={this._sortClass('appointmentspecialistname')}></i>
																			</th>
																			<th
																				onClick={this.sortChanged.bind(this, 'appointmentDate', this.state.sortOrder)}>
																				Appointment Date

                                <i className={this._sortClass('appointmentdate')}></i>
																			</th>
																			<th
																				onClick={this.sortChanged.bind(this, 'appointmentTime', this.state.sortOrder)}>
																				Appointment Time
                                <i className={this._sortClass('appointmenttime')}></i>
																			</th>
																			{/* <th
																				onClick={this.sortChanged.bind(this, 'appointmentTime', this.state.sortOrder)}>
																				Clinic Name
                                <i className={this._sortClass('appointmenttime')}></i>
																			</th> */}
																			<th onClick={this.sortChanged.bind(this, 'appointmentMode', this.state.sortOrder)} >
																				Mode
																	<i className={this._sortClass('appointmentspecialistname')}></i>
																			</th>
																			<th onClick={this.sortChanged.bind(this, 'fee', this.state.sortOrder)}>
																				Consultation Fees
																	<i className={this._sortClass('appointmentspecialistname')}></i>
																			</th>
																			<th
																				onClick={this.sortChanged.bind(this, 'appointmentstatus', this.state.sortOrder)}>
																				Status
                                <i className={this._sortClass('appointmentspecialistname')}></i>
																			</th>
																			<th></th>

																		</tr>
																	</thead>
																	<tbody>{rowsList && rowsList.length > 0 ? rowsList : <tr><td colSpan={9}><p className="text-center noUpcomingTable">There are no {this.state.flag == 1 ? "upcoming" : "past"} appointments.</p></td></tr>}</tbody>
																</table>
															</div>
														</div>

													</div>
												</div>
												{this.state.isRateReminderOpen ? <FeedbackRemainder isOpenModal={this.state.isRateReminderOpen} closeModal={this.closeRemainderModal} doctorName={this.state.doctorName} appointmentDate={this.state.rateAppDate} appointmentTime={this.state.rateAppTime} appointmentId={this.state.rateAppId} openRateCloseRemainder={this.openRateCloseRemainderModal}
													nextRateReminderModal={this.nextRateReminder}

												/> : ''}
												{this.state.isRateModalOpen ? <RateingDisclamer modalOpen={this.state.isRateModalOpen} doctorName={this.state.doctorName} appointmentId={this.state.rateAppId} closeModal={this.closeRateModal}
													openReminder={this.closeRateModalOpenReminder} doctorId={this.state.rateDrId} /> : ''}

												{this.state.isRateModalOpen ? <RateModal modalOpen={this.state.isRateModalOpen} doctorName={this.state.doctorName} appointmentId={this.state.rateAppId} closeModal={this.closeRateModal}
													openReminder={this.closeRateModalOpenReminder} doctorId={this.state.rateDrId} /> : ''}
												{/* {this.state.isDisclaimer ? <RateingDisclamer modalOpen={this.state.isDisclaimer} doctorName={this.state.doctorName} appointmentId={this.state.rateAppId} closeModal={this.closeDisclaimer}
													openReminder={this.closeDisclaimer} doctorId={this.state.rateDrId} /> : ''} */}

												{(appointmentsList && appointmentsList.length > 0) ?
													<div className="row">
														<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
														<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
															<Pagination
																prevPageText='Prev'
																nextPageText='Next'
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCount}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>

														</div>

													</div> : ''}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				}

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
	appointmentList: state.appointment.appointmentList ? state.appointment.appointmentList.appointmentData : '',
		totalCount: state.appointment.appointmentList ? state.appointment.appointmentList.totalCount : 0,
		pendingFeedback: (state.appointment && state.appointment.pendingRate) ? state.appointment.pendingRate : {},

	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MyAppointment);


